import { Box } from "@mui/material";
import { userState } from "../../../interface/MainInterface";
import "./BtnNewBoard.css";
import { useEffect, useRef, useState } from "react";
import { HttpUnAuthApi } from "../../../interface/unauth-api";
import LoadingCircle from "../../../utils/LoadingCircle";
import Toast from "../../../utils/Toast";

interface propsType {
  userState: userState;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const BtnNewBoard = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  const create_scrap_info = async () => {
    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("새로운 보드를 생성하시겠습니까?");
    if (!confirmed) return;

    const param: any = {
      command: "create_scrap_info",
      user_id: props.userState.id,
    };

    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      props.callback({ command: "finish_create_new_scrap" });
    } else {
      toastRef.current?.toast("스크랩 생성에 실패했습니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      <Box className="new-scrap-wrapper">
        <Box className="btn-wrapper">
          <Box sx={{ display: "flex", justifyContent: "center", p: 1 }} className="btn-new-scrap">
            <button onClick={create_scrap_info}>
              <i>
                <span>+ 새로운 보드</span>
              </i>
            </button>
          </Box>
        </Box>
      </Box>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default BtnNewBoard;
